import { render, staticRenderFns } from "./VoiceflowChat.vue?vue&type=template&id=62d7ab8e&scoped=true"
import script from "./VoiceflowChat.vue?vue&type=script&lang=js"
export * from "./VoiceflowChat.vue?vue&type=script&lang=js"
import style0 from "./VoiceflowChat.vue?vue&type=style&index=0&id=62d7ab8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7ab8e",
  null
  
)

export default component.exports